import {NgModule} from '@angular/core';
import {CustomSettingsDialogHeaderComponent} from '@presentation/components/custom-settings-dialog/custom-settings-dialog-header.component';
import {MatchingCriteriaModule} from '@presentation/pages/utilities/tool/add/matching-criteria/matching-criteria.module';
import {CrudOverviewDataModule, EditorHeaderModule, SplitButtonModule} from '@vdw/angular-component-library';
import {TextileDataSharedModule} from '../textile-data-shared.module';
import {AddPlasticProductPageComponent} from './add/add-plastic-product-page.component';
import {PlasticProductSetupComponent} from './add/plastic-product-setup/plastic-product-setup.component';
import {PlasticProductOverviewPageComponent} from './overview/plastic-product-overview-page.component';
import {PlasticProductSelectionModule} from './plastic-product-selection.module';
import {plasticProductRouting} from './plastic-product.routing';
import {PlasticProductCustomSettingsComponent} from './settings/plastic-product-custom-settings.component';

@NgModule({
  declarations: [PlasticProductOverviewPageComponent, AddPlasticProductPageComponent, PlasticProductSetupComponent, PlasticProductCustomSettingsComponent],
  imports: [
    plasticProductRouting,
    TextileDataSharedModule,
    EditorHeaderModule,
    CrudOverviewDataModule,
    SplitButtonModule,
    MatchingCriteriaModule,
    PlasticProductSelectionModule,
    CustomSettingsDialogHeaderComponent
  ]
})
export class PlasticProductModule {}
